var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0L40 32L-1.39876e-06 32L0 -1.74846e-06L40 0Z",
    fill: "#FFDF80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3332 22V20.6667C25.3332 19.9594 25.0522 19.2811 24.5521 18.781C24.052 18.281 23.3737 18 22.6665 18H17.3332C16.6259 18 15.9476 18.281 15.4476 18.781C14.9475 19.2811 14.6665 19.9594 14.6665 20.6667V22",
    stroke: "#806000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 15.3333C21.4724 15.3333 22.6663 14.1394 22.6663 12.6667C22.6663 11.1939 21.4724 10 19.9997 10C18.5269 10 17.333 11.1939 17.333 12.6667C17.333 14.1394 18.5269 15.3333 19.9997 15.3333Z",
    stroke: "#806000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLead);
export default __webpack_public_path__ + "static/media/icon-lead.34fe6f3be887a5a848a5fbc9ec4111ec.svg";
export { ForwardRef as ReactComponent };